import { AddAppointmentData as UsecaseReduxAddAppointmentData } from '~/domain/usecases/appointment/redux';

import { ReduxAddAppointmentData } from '~/data/store/reducer/appointment/usecases';
/**
 * send request via REDUX.
 */
export const makeReduxAddAppointmentData = (): UsecaseReduxAddAppointmentData =>
  new ReduxAddAppointmentData();
